import { useTransition } from '@/shared/hooks/useCinematicTransition';
import { ASSETS } from '@/shared/lib/constants';
import { Typewriter } from './Typewriter';
import { PathwayCard } from './PathwayCard';

export function Hero() {
  const { trigger } = useTransition();

  return (
    <header className="hero">
      <div
        className="hero__image"
        role="img"
        aria-label="Sun rays through dramatic clouds"
      />
      <div className="hero__vignette" />

      <div className="hero__content">
        <h1 className="hero__headline" aria-label="Debate the greatest minds in history">
          <span className="hero__verb">Debate</span>
          <Typewriter />
        </h1>

        <div className="hero__cards">
          <PathwayCard
            to="/worldview"
            variant="craft"
            eyebrow="Available"
            title={
              <>
                Craft Your
                <br />
                World View
              </>
            }
            cta="Build your character"
            bgImage={ASSETS.worldview}
            onTrigger={() =>
              trigger({ to: '/worldview', video: 'worldview', title: 'Craft Your World View' })
            }
          />
          <PathwayCard
            to="/arena"
            variant="arena"
            eyebrow="Available"
            title={
              <>
                Enter the
                <br />
                Arena
              </>
            }
            cta="Begin the debate"
            bgImage={ASSETS.arena}
            onTrigger={() =>
              trigger({ to: '/arena', video: 'arena', title: 'The Floor Is Yours' })
            }
          />
        </div>
      </div>
    </header>
  );
}
